import React, { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/erp";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [permissions, setPermissions] = useState([]);

  const loadPerms = () => http.get("/auth/permissions").then((r) => setPermissions(r.data.permissions || [])).catch(() => setPermissions([]));

  useEffect(() => {
    const token = localStorage.getItem("vg_token");
    if (token) {
      http.get("/auth/me")
        .then((r) => { setUser(r.data); return loadPerms(); })
        .catch(() => { localStorage.removeItem("vg_token"); setUser(false); })
        .finally(() => setReady(true));
    } else {
      setUser(false);
      setReady(true);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    await finishLogin(data);
    return data;
  };

  const finishLogin = async (data) => {
    localStorage.setItem("vg_token", data.token);
    setUser(data);
    await loadPerms();
  };

  const requestOtp = (email) => http.post("/auth/otp/request", { email });

  const loginWithOtp = async (email, code) => {
    const { data } = await http.post("/auth/otp/verify", { email, code });
    await finishLogin(data);
    return data;
  };

  const guest = async () => {
    const { data } = await http.post("/auth/guest");
    localStorage.setItem("vg_token", data.token);
    setUser(data);
    const companies = await http.get("/companies").then((r) => r.data).catch(() => []);
    if (companies.length) {
      localStorage.setItem("vg_company", companies[0].id);
      localStorage.setItem("vg_company_name", companies[0].name);
    }
    await loadPerms();
    return data;
  };

  const logout = () => {
    localStorage.removeItem("vg_token");
    localStorage.removeItem("vg_company");
    localStorage.removeItem("vg_company_name");
    setUser(false);
    setPermissions([]);
  };

  const can = (perm) => permissions.includes(perm);

  return (
    <AuthContext.Provider value={{ user, ready, login, requestOtp, loginWithOtp, guest, logout, permissions, can }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
